import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M9.187 14.25c0-.103-.083-.188-.187-.188-.103 0-.187.084-.187.188 0 .103.084.187.187.187.104 0 .187-.084.187-.187Zm0-5.25c0-.104-.083-.187-.187-.188-.103 0-.187.084-.187.188 0 .103.084.187.187.187.104 0 .187-.084.187-.187Zm0-5.25c0-.103-.083-.187-.187-.187-.103 0-.187.084-.187.187 0 .104.084.188.187.188.104 0 .187-.085.187-.188Zm1.125 5.25c0 .725-.587 1.313-1.312 1.313-.725 0-1.313-.588-1.313-1.313 0-.725.588-1.313 1.313-1.313.725 0 1.312.588 1.312 1.313Zm0-5.25c0 .725-.587 1.312-1.312 1.312-.725 0-1.313-.587-1.313-1.312 0-.725.588-1.313 1.313-1.313.725 0 1.312.588 1.312 1.313Zm0 10.5c0 .725-.587 1.313-1.312 1.313-.725 0-1.313-.588-1.313-1.313 0-.725.588-1.312 1.313-1.312.725 0 1.312.587 1.312 1.312Z"
      fill="currentColor"
    />
  </svg>
);

export { SvgComponent as DotsVerticalIcon };

